// overrides history.pushState an history.replaceState to fire a custom event whenever
// the functions are called (which react router calls) - lets us listen for location

import { getLogger } from "./debug-logger";

// updates outside of the router (ie: in Alerts, Modals, custom scripts, etc)
const log = getLogger('bl:history-listener');

class Trace extends Error {
	constructor(message?: string) {
		super(message);
		this.name = 'Trace';
	}
}

export default (function() {
	const pushState = history.pushState;
	const replaceState = history.replaceState;

	history.pushState = function(...args: unknown[]) {
		pushState.apply(history, args as any);
		log('pushState', args, new Trace().stack);
		window.dispatchEvent(new Event('pushstate'));
		window.dispatchEvent(new Event('locationchange'));
	};

	history.replaceState = function(...args: unknown[]) {
		log('replaceState', args, new Trace().stack);
		replaceState.apply(history, args as any);
		window.dispatchEvent(new Event('replacestate'));
		window.dispatchEvent(new Event('locationchange'));
	};

	window.addEventListener('popstate', function() {
		window.dispatchEvent(new Event('locationchange'));
	});
})();